import { makeStyles } from "@material-ui/core";
import { EContractStatus } from "api/enums";
import { lang } from "i18nLang";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const useStyle = makeStyles((theme) => ({
  chart: {
    "& .recharts-legend-item-text": {
      color: `${theme.palette.gray[900]} !important`,
    },
  },
}));

const ContractDonutChart = ({
  series,
}: {
  series: { [status: string]: number };
}) => {
  const classes = useStyle();

  const data = Object.values(EContractStatus).map((stt) => ({
    name: lang(`kanban.status.${stt}`),
    value: series[stt],
  }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <PieChart className={classes.chart} width={400} height={320}>
        <Pie dataKey="value" data={data} innerRadius={90} outerRadius={110}>
          <Cell fill={"#137CBD"} />
          <Cell fill={"#FABE24"} />
          <Cell fill={"#D73912"} />
          <Cell fill={"#0E8755"} />
          <Cell fill={"#424242"} />
        </Pie>
        <Tooltip />
        <Legend verticalAlign="bottom" iconType="circle" height={36} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ContractDonutChart;
